<c-money-base-page [mode]="'edit'" [paymentToEdit]="paymentToEdit" />
